import { useCallback, useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import { INotice } from "../../../../interfaces";
import { INoticeInputs } from "../../interfaces";

import useAuth from "../../../../hooks/useAuth";


export default function useNoticeForm(
    onSubmit: (notice: INotice) => Promise<void>,
    notice: INotice | undefined,
) {
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [defaultEditorState] = useState<any>(undefined);
    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty());

    const isEditing = useRef<boolean>(!!notice);

    const { activeCity } = useAuth();

    const content = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
    );

    const handleSubmitForm: SubmitHandler<INoticeInputs> = async (data) => {
        setIsSubmiting(true);

        const finalContent = draftToHtml(
            convertToRaw(editorState.getCurrentContent()),
        );

        if (finalContent.replace("<p></p>", "").trim().length === 0) {
            setError('content', { message: 'Por favor, preencha o corpo da mensagem.' });
            setIsSubmiting(false);
            return;
        }

        const noticeData: INotice = {
            ...data,
            content: finalContent,
        };


        await onSubmit(noticeData);

        setIsSubmiting(false);
    };

    const {
        handleSubmit,
        formState: { errors },
        control,
        setError,
        clearErrors,
        watch,
    } = useForm<INoticeInputs>({
        defaultValues: {
            title: notice?.title || '',
            content: notice?.content || '',
            status: notice?.status || 'true',
            city_id: activeCity?.id,
        }
    });

    const title = watch('title');

    const onChangeEditor = useCallback((editorState: EditorState): void => {
        if (errors.content?.message) {
            clearErrors("content");
        }
        setEditorState(editorState);
    }, [errors, clearErrors]);

   
    useEffect(() => {
        if (!notice) {
            return;
        }

        const controller = new AbortController();


        const contentBlocks = htmlToDraft(
            notice.content || 'Corpo da mensagem'
        );

        const sampleEditorContent =
            ContentState.createFromBlockArray(
                contentBlocks.contentBlocks,
                contentBlocks.entityMap
            );
        const editorState = EditorState.createWithContent(sampleEditorContent);

        setEditorState(editorState);

        return () => {
            controller.abort();
        }

    }, [notice]);

    return {
        handleSubmitForm,
        handleSubmit,
        control,
        isSubmiting,
        errors,
        defaultEditorState,
        editorState,
        onChangeEditor,
        isEditing,
        content,
        title,
    }
}
